import Base from '../../../../Core/Base.js';
import Events from '../../../../Core/mixin/Events.js';

/**
 * @module Grid/feature/export/consumer/ConsumerBase
 */

/**
 * Base class for consumers of the output from the exporters.
 *
 * @mixes Core/mixin/Events
 * @internal
 */
export default class ConsumerBase extends Base.mixin(Events) {
    static configurable = {
        abortController : null,

        openAfterExport : null
    };

    /**
     * Initiates consumer operation. Exporter will wait for consumer to be ready.
     *
     * @param {Object} config Export configuration object
     * @returns {Promise} A promise that resolves when the start process completes.
     */
    async start(config) {}

    /**
     * Accepts generated page from the exporter. Although declared async, exporter will not wait
     * for consumer to resolve this promise and will keep generating pages.
     * @param {Object} page
     * @param {String} page.html
     * @returns {void}
     */
    async consumePage(page) {
        throw new Error('Method consumePage must be implemented in a subclass');
    }

    /**
     * Called after exporter has finished.
     *
     * @returns {Promise}
     */
    async end() {}

    /**
     * Interface for collecting results in an asynchronous manner.
     * @param {Object} config Export configuration object
     */
    async finalize(config) {
        throw new Error('Method collectResult must be implemented in a subclass');
    }
}
